import { HomeTasksController } from './home-tasks.controller'

function homeTasks () {
  return {
    restrict: 'E',
    templateUrl: '/home/directives/home-tasks/home-tasks-directive.html?$$REVISION$$',
    controller: HomeTasksController
  }
}

export { homeTasks }
